<template>
    <div class="login">
        <div class="mainContent">
          <div class="title">
            服装综合体官网管理后台
          </div>
            <div class="tabPanel">
                <div class="tabsBox">
                    <div class="textLine">
                        <div class="tab" :class="{active:tab==1}" @click="toggleTab(1)">验证码登录</div>
                        <div class="tab" :class="{active:tab==2}" @click="toggleTab(2)">密码登录</div>
                    </div>
                   <div class="imgLine">
                        <!-- <img src="../../assets/images/icon/icon_line.png" alt="" class="borderImg" :class="{left:tab==1,right:tab==2}"> -->
                        <div  class="borderImg" :class="{left:tab==1,right:tab==2}">
                          <div class="redLine"></div>
                        </div>
                    </div>
                </div>
                <div class="inputBox" v-show="tab==1">
                    <el-form :model="formObj" :rules="rules" ref="form" label-width="0px" >
                        <el-form-item prop="phone">
                          <div class="oneInputLine">
                            <span class="inputLabel">手机号</span>
                            <el-input class="phoneInput" type="text" placeholder="请输入手机号" v-model="formObj.phone"
                                autocomplete="off" clearable @keyup.enter.native="submitForm('form')"></el-input>
                          </div>

                        </el-form-item>
                        <el-form-item prop="code">
                          <div class="oneInputLine">
                            <span class="inputLabel">验证码</span>
                            <el-input class="codeInput" type="text" placeholder="请输入6位验证码" @keyup.enter.native="submitForm('form')"
                              v-model="formObj.code" autocomplete="off"  show-password></el-input>
                              <div class="codeButton" @click="sendCode" size="mini" :disabled="isDisabledCode">{{codeMsg}}</div>
                          </div>

                        </el-form-item>
                        <el-form-item class="longButtonBox">
                            <el-button type="primary" class="submitButton" @click="submitForm('form')"
                                :loading="isLoading">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="inputBox" v-show="tab==2">
                    <el-form :model="formObj_pwd" :rules="rules" ref="form_pwd" label-width="0px">
                        <el-form-item prop="phone">
                          <div class="oneInputLine">
                            <span class="inputLabel">手机号</span>
                             <el-input class="phoneInput" type="text" placeholder="请输入手机号" v-model="formObj_pwd.phone"
                                 autocomplete="off" clearable @keyup.enter.native="submitForm('form_pwd')"></el-input>
                          </div>

                        </el-form-item>
                        <el-form-item prop="pwd">
                          <div class="oneInputLine">
                            <span class="inputLabel">密码</span>
                            <el-input class="pwdInput" type="text" placeholder="请输入密码" @keyup.enter.native="submitForm('form_pwd')"
                                v-model="formObj_pwd.pwd" autocomplete="off"  show-password></el-input>
                          </div>

                        </el-form-item>
                        <el-form-item class="longButtonBox">
                            <el-button type="primary" class="submitButton " @click="submitForm('form_pwd')"
                                :loading="isLoading">登录</el-button>
                        </el-form-item>
                    </el-form>

                </div>
            </div>


        </div>

    </div>
</template>

<script>
    import {        utils,        json    } from '@/common/common.js'
    import {        api ,ajaxLogin   } from '@/common/request.js'
    export default {
        data() {

            var validatePhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机不能为空'));
                }
                setTimeout(() => {
                    const reg = json.phoneReg
                    if (!reg.test(value)) {
                        callback(new Error('手机格式不正确'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            var validateCode = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入验证码'));
                } else {
                    if (value.length != 6) {
                        callback(new Error('验证码为6位数字'));
                    } else {
                        callback();
                    }
                }
            };
            var validatePwd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                winSystem:'',
                isSupport:'',
                currentGoogleUrl:'',
                tab: 1,
                formObj_pwd: {
                    phone: "",
                    pwd: '',
                },
                formObj: {
                    phone: '',
                    code: '',
                },
                rules: {
                    phone: [{
                        validator: validatePhone,
                        trigger: 'blur'
                    }],
                    code: [{
                        validator: validateCode,
                        trigger: 'blur'
                    }],
                    pwd: [{
                        validator: validatePwd,
                        trigger: 'blur'
                    }]
                },
                isDisabledCode: false,
                codeMsg: "发送验证码",
                isLoading: false,
                //登录以后的
                userInfoObj:{},
                // platAndMenuInfo:[],
                platInfo:[],
            };
        },
        computed: {
            allPlatLists() {
                let platsData=[]
                if(utils.getCurrentApi()=='dev'){
                    platsData=json.platLists_dev
                }
                if(utils.getCurrentApi()=='test'){
                    platsData=json.platLists_test
                }
                if(utils.getCurrentApi()=='prod'){
                    platsData=json.platLists_prod
                }

                let result=[]
                platsData.forEach(function(item,index){
                    let buffer={
                        text:item.text,
                        value: item.value,
                        url:item.url.split("#")[0]
                    }
                    result.push(buffer)
                })
                return result
            }
        },
        methods: {
            hrefToOtherPlat(list){
                let url=list.url
                window.open(url,'_blank')
            },
            toggleTab(index) {
                this.tab = index
            },
            sendCode() {
                let _this = this
                const reg = /^1(3|4|5|6|7|8|9)[0-9]{9}$/
                if(! reg.test(this.formObj.phone)){
                    _this.$message({
                    	message: "手机号码格式不正确",
                    	type: 'error',
                    	duration: 1500
                    });
                }else  if (!_this.isDisabledCode) {
                    let num = 60
                    _this.codeMsg = '已发送' + num + 's'
                    _this.isDisabledCode = true
                    let arg={phone:_this.formObj.phone}
                    ajaxLogin('/admin/yijiajiaUserInfo/RequestPhoneCode', arg).then(function(res) {
                        if (res.errorCode == 200) {
                            _this.$message({
                            	message: "发送成功",
                                type:'success',
                            	duration: 1500
                            });
                        }
                    }, function(res) {
                    })

                    let timer = setInterval(function() {
                        if (num > 1) {
                            num--
                            _this.codeMsg = '已发送' + num + 's'
                            _this.isDisabledCode = true
                        } else {
                            _this.codeMsg = '发送验证码'
                            _this.isDisabledCode = false
                            clearInterval(timer)
                            timer = null
                        }
                    }, 1000)
                }
            },
            setSessionStorageInfo(){
                //1.登录时的存储信息 ：登录标记，个人信息，平台列表，菜单列表
                let _this=this
                // console.log(_this.platAndMenuInfo,'登陆成功时放在cookie里的菜单，所有【平台的--------')
                 console.log("获取登录信息成功，开始放入cookie------isLoginedSZHC-------userInfo_multiActive--------platInfo_multiActive--------------")
                utils.setCookie("isLoginedSZHC", 'y',20)//isLoginedYjjAdminMultiActive
                utils.setCookie("userInfo_multiActive", JSON.stringify(_this.userInfoObj),1)
                utils.setCookie("platInfo_multiActive", JSON.stringify(_this.platInfo),1)

            },
            ajaxSubmit(arg) {
                let _this = this
                // console.log(arg)
                _this.isLoading = true
                ajaxLogin('/admin/user/checkLogin', arg).then(function(res) {
                    _this.isLoading = false
                    if (res.errorCode == 200) {
                        _this.isLoading = false
                        //1.获取菜单，buyongle
                        // if(res.data.menu){
                        //     _this.platAndMenuInfo=JSON.parse(res.data.menu)
                        //     // console.log(_this.platAndMenuInfo,"系统传过来的menu 所有平台的----------")
                        // }
                        //2.组装菜单和平台信息，(不用了)
                        // _this.resetLeftMenu(allMenuInfo)
                        //1.获取平台信息
                        if(res.data.menu){
                            _this.platInfo=[]
                            let arr=JSON.parse(res.data.menu).sysIdList
                            console.log(arr,"------------------------")
                            arr.forEach(function(item,index){
                                let buffer={
                                    sysId: item.sysId,
                                    sysSystemName:item.sysSystemName,
                                    url: item.sysDomainName
                                }
                                _this.platInfo.push(buffer)
                            })
                            console.log(_this.platInfo,"_this.platInfo--------------------")
                        }
                        //2.组装个人信息，
                         _this.userInfoObj={
                            adminId:res.data.adminId,
                            userLoginToken:res.data.userLoginToken,
                            yijiajiaUserToken:res.data.yijiajiaUserToken,
                            companyName:res.data.adminCompanyName,
                            realName:res.data.adminRealname,
                            phone:res.data.adminCellphone,
                            roleId:res.data.roleId,
                            position:res.data.adminPosition
                        }
                        //3.把信息放入session里，然后跳转
                        _this.setSessionStorageInfo()
                        _this.$router.push("/home")

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            submitForm(formName) {
                let _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(formName=='form'){
                            // console.log("验证码登录")
                            let arg={
                                "phone":_this.formObj.phone,
                                "code" :_this.formObj.code,
                                "userDeviceInfo":"pc",
                                "type":"1",
                            }
                            _this.ajaxSubmit(arg)
                        }
                        if(formName=='form_pwd'){
                            // console.log("密码登录")
                            let arg={
                                "phone"      :_this.formObj_pwd.phone,
                                "adminPasswd":_this.formObj_pwd.pwd,
                                "userDeviceInfo":"pc",
                                "type":"2",
                            }
                            _this.ajaxSubmit(arg)
                        }
                    } else {
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped="scoped">
    .whiteTipBox{
        padding:30px 0;
        background: rgba(255,255,255,0.8); border-radius: 6px;
         text-align: center; font-size: 20px;
        line-height: 40px;
         position: fixed;
         width: 400px;
         height: 130px;
         top:0;bottom: 0;right:0;left:0;margin:auto;

    }
    .login {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: url("../../assets/images/pic/login_bg.jpg") no-repeat;
        background-position: top center;
        background-size: cover;
        overflow: hidden;

        .platHrefWrap{
            position: absolute;right:10px;top:10px;
        }
        .mainContent {
            position: absolute;
            right: 0;
            left: 0;
            top:0;bottom:0;
            margin: auto;
            background: rgba(255, 255, 255, 1);
            border-radius: 6px;
            padding: 40px 45px 60px;
            transform: translateY(50px);
            // 460*370
            width: 370px;
            height: 270px;

            .title {
                position:absolute;
                top:-90px;
                left:0;right:0;
                text-align: center;
                color: #333;
                // font-weight: bold;
                font-size: 32px;
            }

            .tabsBox {
                .textLine {
                    display: flex;
                    .tab {
                        flex: 1;
                        text-align: center;
                        // padding: 0.3rem 0;
                        padding-bottom: 0;
                        color: #333333;
                        font-size:20px;
                        cursor: pointer;
                        letter-spacing:1px;
                        font-weight: bold;
                    }

                    .tab.active {
                        color: #F81D22;
                        font-weight: bold;
                    }
                }

                .imgLine {
                    height: 2px;
                    // background: #999;
                    position: relative;
                    border-radius: 0.1rem;

                    .borderImg {
                        height: 2px;
                        width: 50%;
                        position: absolute;
                        top: -2px;
                        text-align: center;
                        .redLine{background: red;height: 3px;width: 78px;display: inline-block;}
                    }

                    .borderImg.left {
                        left: 0;
                    }

                    .borderImg.right {
                        right: 0;
                    }
                }
            }

            .inputBox {
                // background: #eee;
                margin-top:40px;
                .oneInputLine{
                  position: relative; height:43px; line-height: 43px;
                  border:1px solid rgba(231,231,231,1);
                  .inputLabel{
                    position: absolute;left:0;top:6px; color:#2A2E3F;font-size: 14px;

                    width: 80px; text-align: center;
                    height: 30px; line-height: 30px;
                    border-right: 1px solid #E7E7E7;
                  }
                  .codeButton {
                      position: absolute;right:9px;top:6px;
                      color: #333333;
                      text-align: center;
                      padding-left:19px;
                      padding-right:19px;
                      font-size: 12px;
                      line-height: 31px;
                      height:31px;
                      cursor: pointer;
                      background:#eee;
                      border-radius:16px;
                  }

                  .codeButton:hover {
                      background: #eee;
                      color: #333333;
                  }

                  .codeButton[disabled],
                  .codeButton[disabled]:hover {
                      color: #999;
                      border-color: #999;
                      cursor: not-allowed;
                      background: transparent;
                  }
                }

                .phoneInput {
                    // background: url("../../assets/images/icon/icon_person.png") no-repeat 0.3rem 0.29rem;
                    // background-size: 0.38rem 0.35rem;
                }

                .pwdInput,
                .codeInput {
                    // background: url("../../assets/images/icon/icon_lock.png") no-repeat 0.3rem 0.29rem;
                    // background-size: 0.38rem 0.35rem;
                }



                .submitButton {
                    width: 100%;
                    margin-top:26px;
                    font-size:20px;letter-spacing:1px;
                    background:rgba(248,29,34,1);
                    border-radius:2px;
                    font-weight:300;
                    border:0;
                    outline: 0;
                }
                .submitButton:hover{background:rgba(208,19,14,1);}

                .longButtonBox {
                    margin-bottom: 0;
                }
            }


        }
    }

    .tabContent {
        height: 6.2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue